import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0a4bf808&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0a4bf808&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4bf808",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a4bf808')) {
      api.createRecord('0a4bf808', component.options)
    } else {
      api.reload('0a4bf808', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0a4bf808&scoped=true", function () {
      api.rerender('0a4bf808', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboard/account/views/index.vue"
export default component.exports